export enum LessonTutorAvailability {
  Available = 'AVAILABLE',
  OutOfSchedule = 'OUT_OF_SCHEDULE',
  Unavailable = 'UNAVAILABLE',
}

export enum LessonTutorSpecialFeature {
  Adhd = 'ADHD',
  Personalise = 'PERSONALISE',
  Grade = 'GRADE',
}

export enum LessonsSortDirection {
  Desc = 'DESC',
  Asc = 'ASC',
}

export enum LessonScheduleType {
  Single = 'SINGLE',
  Regular = 'REGULAR',
}

export enum LessonsBulkDeleteMode {
  ByIds = 'BY_IDS',
  Reserved = 'RESERVED',
}

/** The confirmation open on the Lessons tab: one lesson, the ticked ones, or every reserved one. */
export enum LessonsDeleteModal {
  Single = 'single',
  Selected = 'selected',
  Reserved = 'reserved',
}

export enum LessonConnectionParticipant {
  Customer = 'CUSTOMER',
  Tutor = 'TUTOR',
}

export enum LessonConnectionTier {
  Good = 'GOOD',
  Unstable = 'UNSTABLE',
  Weak = 'WEAK',
  Lost = 'LOST',
}

/** The modal open on the Lessons tab besides the delete confirmations. */
export enum LessonsActionModal {
  Cancel = 'cancel',
  Reschedule = 'reschedule',
  BulkEdit = 'bulk-edit',
}

/** What a link from a row of the Lessons tab asks the lesson page to open on arrival. */
export enum LessonEntryAction {
  Cancel = 'cancel',
  Reschedule = 'reschedule',
  Delete = 'delete',
}
